'use client';

import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import { getENV } from '../../../../utils/env';
import PrivacyOptionsIcon from './privacyoption.icon.svg';
import './OneTrustButton.scss';
type OneTrustButtonProps = {
  label?: string;
  className?: string;
};
export const OneTrustButton = t0 => {
  const $ = _c(8);
  const {
    label: t1,
    className
  } = t0;
  const label = t1 === undefined ? "Your Privacy Choices" : t1;
  const handleClick = _temp;
  let t2;
  if ($[0] !== className) {
    t2 = cn("ot-custom-button", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <span className="ot-custom-button__label">{label}</span>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PrivacyOptionsIcon aria-hidden="true" focusable="false" height="14" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t3) {
    t5 = <button type="button" id="ot-sdk-btn" className={t2} onClick={handleClick}>{t3}{t4}</button>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
function _temp() {
  if (window?.Optanon?.ToggleInfoDisplay) {
    window.Optanon.ToggleInfoDisplay();
    return;
  }
  globalThis.location.href = getENV("NEXT_PUBLIC_ONETRUST_FALLBACK_URL");
}